module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "links"
  }, [(_vm.filters.name || _vm.filters.tags.length) ? _c('div', {
    staticClass: "filters"
  }, [_c('div', {
    staticClass: "tip"
  }), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, [(_vm.filters.name) ? _c('div', {
    staticClass: "item name"
  }, [_c('span', [_vm._v(_vm._s(_vm.filters.name))]), _vm._v(" "), _c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.handleFilterClear('name')
      }
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filters.tags), function(tag, i) {
    return _c('div', {
      key: i,
      staticClass: "item tag"
    }, [_c('span', [_vm._v(_vm._s(tag))]), _vm._v(" "), _c('span', {
      staticClass: "close",
      on: {
        "click": function($event) {
          _vm.handleFilterClear('tag', tag)
        }
      }
    })])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "items"
  }, [_c('div', {
    ref: "container",
    staticClass: "wrapper"
  }, _vm._l((_vm.filteredLinks), function(link) {
    return _c('div', {
      key: link.name,
      class: ( _obj = {
        link: true
      }, _obj['link-' + link.name.toLowerCase()] = true, _obj ),
      style: ({
        width: _vm.itemWidth + 'px'
      })
    }, [_c('div', {
      staticClass: "item"
    }, [_c('a', {
      attrs: {
        "href": link.href,
        "target": link.href.indexOf('http') === 0 ? '_blank' : '_self'
      }
    }, [_c('div', {
      staticClass: "icon",
      style: ({
        'background-image': ("url(" + (_vm.staticDir + link.icon) + ")")
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(link.name))])])])])
    var _obj;
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07f3990a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Links.vue
// module id = 61
// module chunks = 1